/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
export default class FrontendURLs {
  static getBaseUrl() {
    return '/';
  }

  static getMachine(machine: { TypeDefinition: string; MachineId: string; Encoding: number }, fairTag?: string) {
    let url = FrontendURLs.getBaseUrl();
    if (fairTag) {
      url = url.concat(`${fairTag}/`);
    } else {
      url = url.concat('all/');
    }
    return url.concat(
      `${encodeURIComponent(machine.TypeDefinition)}/${encodeURIComponent(machine.MachineId)}?v=${machine.Encoding == 0 || machine.Encoding == null ? '2' : machine.Encoding}`,
    );
  }

  static getMachineWoEncoding(machine: { TypeDefinition: string; MachineId: string }, fairTag?: string) {
    let url = FrontendURLs.getBaseUrl();
    if (fairTag) {
      url = url.concat(`${fairTag}/`);
    } else {
      url = url.concat('all/');
    }
    return url.concat(`${encodeURIComponent(machine.TypeDefinition)}/${encodeURIComponent(machine.MachineId)}`);
  }

  static getSoftware(softwareId: string, fairTag?: string) {
    let url = FrontendURLs.getBaseUrl().concat('software/');
    if (fairTag) {
      url = url.concat(`${fairTag}/`);
    } else {
      url = url.concat('all/');
    }
    return url.concat(`${encodeURIComponent(softwareId)}`);
  }

  static getFair(fair) {
    return FrontendURLs.getBaseUrl().concat(`machines/${fair}/`);
  }

  static getList(item: 'overview' | 'machines' | 'software', fairTag: string = 'all', anchor?: string) {
    return FrontendURLs.getBaseUrl().concat(`${item}/${fairTag}/${anchor ? `#${anchor}` : ''}`);
  }
}
